export default __webpack_public_path__ + "static/media/opentextcup.57672d0d.jpg";